"use client";

import { useEffect, useState } from "react";
import { LOCALE_PREFERENCES_CHANGE_EVENT, readLocalePreferences, type LocalePreferences } from "@/lib/locale-preferences";
import { getUserCenterCopy, normalizeUserCenterLocale } from "@/lib/user-center-i18n";

export function useUserCenterLocale() {
  const [locale, setLocale] = useState(() => normalizeUserCenterLocale(readLocalePreferences().language));

  useEffect(() => {
    const sync = (event?: Event) => {
      const preferences = event instanceof CustomEvent ? event.detail as LocalePreferences : readLocalePreferences();
      setLocale(normalizeUserCenterLocale(preferences.language));
    };
    sync();
    window.addEventListener(LOCALE_PREFERENCES_CHANGE_EVENT, sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener(LOCALE_PREFERENCES_CHANGE_EVENT, sync);
      window.removeEventListener("storage", sync);
    };
  }, []);

  return { locale, copy: getUserCenterCopy(locale) };
}
